import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Service to use ngx-toastr with custome style
 */
export class SnackBarService {
  constructor(
    private ToastrService: ToastrService,
    private languageService: LanguageService,
    private TranslateService: TranslateService
  ) {}

  success(text: string, title:string="", closeButton:boolean = false) {
    this.ToastrService.success(this.TranslateService.instant(text), title, {
      timeOut: 10000,
      closeButton:closeButton,
      positionClass:
        this.languageService.selectedLanguage== 'ar'
          ? 'toast-bottom-left'
          : 'toast-bottom-right',
    });
  }
  error(text: string,title:string="", closeButton:boolean = false) {
    this.ToastrService.error(this.TranslateService.instant(text), title, {
      timeOut: 10000,
      closeButton:closeButton,
      positionClass:
        this.languageService.selectedLanguage== 'ar'
          ? 'toast-bottom-left'
          : 'toast-bottom-right',
    });
  }
  backEndError(text: any,title:string="", closeButton:boolean = false){
    // let msg = this.languageService.dir$.getValue() == 'rtl' ? text.ar : text.en
    this.ToastrService.error(text, title, {
      timeOut: 5000,
      closeButton:closeButton,
      positionClass:
        this.languageService.selectedLanguage== 'ar'
          ? 'toast-bottom-left'
          : 'toast-bottom-right',
    });
  }
  warning(text: string,title:string="", closeButton:boolean = false) {
    this.ToastrService.warning(this.TranslateService.instant(text), title, {
      timeOut: 10000,
      closeButton:closeButton,
      positionClass:
        this.languageService.selectedLanguage== 'ar'
          ? 'toast-bottom-left'
          : 'toast-bottom-right',
    });
  }

  notification(text: string,title:string="", closeButton:boolean = false) {
    this.ToastrService.success(this.TranslateService.instant(text), title, {
      timeOut: 50000,
      closeButton:closeButton,
      positionClass:
        this.languageService.selectedLanguage== 'ar'
          ? 'toast-bottom-left'
          : 'toast-bottom-right',
    });
  }

  info(text: string,title:string="", closeButton:boolean = false) {
    this.ToastrService.info(this.TranslateService.instant(text), title, {
      timeOut: 10000,
      closeButton:closeButton,
      positionClass:
        this.languageService.selectedLanguage== 'ar'
          ? 'toast-bottom-left'
          : 'toast-bottom-right',
    });
  }
}
